const config = {
  AVATAR_PREFIX: 'https://metis-online.fbcontent.cn/metis-account/metis-avatar/',
  jpg1m: 'https://maple-online.fbcontent.cn/public/release/speed/1m.jpg',
  jpg3m: 'https://maple-online.fbcontent.cn/public/release/speed/3m.jpg',
  jpg5m: 'https://maple-online.fbcontent.cn/public/release/speed/5m.jpg',
  HTTP_BASE_URL: 'https://mapi.feixiangxingqiu.com',
  LECTIO_URL: 'https://ke.feixiangxingqiu.com/#/',
  ZHIXUE_URL: 'https://zhixue.feixiangxingqiu.com/#/',
  TEMPLATE: {
    TEACHER_INFO: 'https://metis-online.fbcontent.cn/metis-misc/flying/LW9Y9ezrOBCAKlYiG3NXeR.xlsx',
    STUDENT_INFO: 'https://metis-online.fbcontent.cn/metis-misc/flying/eUgeVpvadfsu0KxAh0cJPF.xlsx',
    TEACH: 'https://metis-online.fbcontent.cn/metis-misc/flying/w5OqWndikOXaV1kzfofm5.xlsx',
  },
  FROG: {
    APPID: 'metis-flying-customer-web',
    TOKEN: 'ee19805fb2fc47cbbda9ce72461967cf',
    PRODUCT_ID: 21000047,
  },
  loginURL: 'https://login.feixiangxingqiu.com/flying/#/login',
}

export default config
